export const validatePassword = (password) => {
    if (!password) return false;

    /**
     * Breakdown:
     * ^                         Start of string
     * (?=.*[a-z])               Must contain at least one lowercase letter
     * (?=.*[A-Z])               Must contain at least one uppercase letter
     * (?=.*\d)                  Must contain at least one number
     * (?=.*[@$!%*?&^#+\-\/])    Must contain at least one special character
     * [A-Za-z\d@$!%*?&^#+\-\/ ]{8,}  Min 8 chars of these specific types
     * $                         End of string
     */
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\w@$!%*?&^#+\-\/ ]{8,}$/;
    
    return regex.test(password);
}

export const passwordRequirements = "Password must be at least 8 characters long and include uppercase, lowercase, numbers, and special characters.";